import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import CombinatorHeaderConfiguration from "../components/CombinatorHeaderConfiguration";
import CombinatorInputPortList from '../components/CombinatorInputPortList';
import PanelLayout from "../components/PanelLayout";

class CombinatorPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "Combinator",
        };
        this.changeTab = this.changeTab.bind(this);
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    render() {
        return (
            <PanelLayout
                headerTabs={
                    <span data-id="Combinator" onClick={this.changeTab}
                          className={this.state.selectedTab === "Combinator" ? "navigation-tab current" : "navigation-tab"}>Combinator</span>
                }
                customTabs
            >
                <div
                    className={this.state.selectedTab === "Combinator" ? "gui-editor-content active" : "gui-editor-content"}>
                    <CombinatorHeaderConfiguration />
                    <CombinatorInputPortList/>
                </div>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node
    }
}

export default connect(mapStateToProps, {hideModal})(CombinatorPanel);